export const ProductsMap = {
    // #region Other
    'BDL-01': {
        title: 'BDL-01',
        subtitle: 'AWR Balustrade Designer Link',
        price: 0
    },
    S03: {
        title: 'S03',
        subtitle: 'Cut, Measure and Factory Hydraulic Swage 3.2mm (Per End)',
        thumbnailUrl: '/images/products/S03.jpg',
        price: 2.75,
        link: 'https://www.awrsolutions.com.au/products/cut-and-factory-hydraulic-swage-3-2mm'
    },
    // #endregion
    // #region Wires
    'WRS119316-032-MTR': {
        title: 'WRS119316-032-MTR',
        subtitle: '3.2mm 1 x 19 Wire Rope 316 Grade (Additonal cost Charged per Metre)',
        thumbnailUrl: '/images/products/WRS119316-032-MTR.jpg',
        price: 1.48,
        link: 'https://www.awrsolutions.com.au/products/1-x-19-wire-rope-316-stainless'
    },
    'BWRS119316-032-MTR': {
        title: 'BWRS119316-032-MTR',
        subtitle: '3.2mm 1 x 19 Wire Rope 316 Grade (Additonal cost Charged per Metre)',
        thumbnailUrl: '/images/products/BWRS119316-032-MTR.jpg',
        price: 1.55,
        link: 'https://www.awrsolutions.com.au/products/blacketch-3-2mm-1-x-19-wire-rope-316-stainless-per-metre'
    },
    // #endregion
    // #region Timber systems
    // Rig Fork Saddles
    'WBS-RFSAD': {
        title: 'WBS-RFSAD',
        subtitle: 'Wire Balustrades Rig Fork System with Saddles',
        thumbnailUrl: '/images/products/WBS-RFSAD.jpg',
        price: 8.06,
        link: 'https://www.awrsolutions.com.au/products/bright-finish-factory-swaged-wire-balustrade-rig-fork-system-with-saddles-suits-timber-posts'
    },
    'WBSB-RFSAD': {
        title: 'WBSB-RFSAD',
        subtitle: 'Wire Balustrade Rig Fork System with Saddles BLACK',
        thumbnailUrl: '/images/products/WBSB-RFSAD.jpg',
        price: 9.89,
        link: 'https://www.awrsolutions.com.au/products/blacketch-factory-swaged-wire-balustrade-rig-fork-with-saddles'
    },
    // Rig Fork Screw Eyes
    'WBS-RFSE': {
        title: 'WBS-RFSE',
        subtitle: 'Wire Balustrades Rig Fork System with Screw Eyes',
        thumbnailUrl: '/images/products/WBS-RFSE.jpg',
        price: 9.61,
        link: 'https://www.awrsolutions.com.au/products/bright-finish-factory-swaged-wire-balustrade-rig-f-with-screw-eyes'
    },
    'WBSB-RFSE': {
        title: 'WBSB-RFSE',
        subtitle: 'Wire Balustrades Rig Fork System with Screw Eyes Black',
        thumbnailUrl: '/images/products/WBSB-RFSE.jpg',
        price: 11.65,
        link: 'https://www.awrsolutions.com.au/products/blacketch-factory-swaged-wire-balustrade-rig-fork-system-with-screw-eyes-suits-timber-posts'
    },
    // Timber Insert
    'WBS-TIS': {
        title: 'WBS-TIS',
        subtitle: 'Bright Finish Factory Swaged Wire Balustrade - Timber Insert System - Suits Timber Posts',
        thumbnailUrl: '/images/products/WBS-TIS.jpg',
        price: 7.96,
        link: 'https://www.awrsolutions.com.au/products/timber-insert-wire-balustrade-system-suits-timber-posts'
    },
    'WBSB-TIS': {
        title: 'WBSB-TIS',
        subtitle: 'BlackEtch Factory Swaged Wire Balustrade - Timber Insert System - Suits Timber Posts',
        thumbnailUrl: '/images/products/WBSB-TIS.jpg',
        price: 9.27,
        link: 'https://www.awrsolutions.com.au/products/blacketch-factory-swaged-wire-balustrade-timber-in-system'
    },
    // Adaptors
    'BS-7813L-0615': {
        title: 'BS-7813L-0615',
        subtitle: 'BlackEtch Angle Connector M6 x 15mm Left Hand Thread - 316 Grade Stainless Steel',
        thumbnailUrl: '/images/products/BS-7813-0615.jpg',
        price: 6.37,
        link: 'https://www.awrsolutions.com.au/products/blacketch-angle-connector-m6-x-15mm-left-hand-thread-316-stainless'
    },
    'BS-7813R-0615': {
        title: 'BS-7813-0615',
        subtitle: 'BlackEtch Angle Connector M6 x 15mm Right Hand Thread - 316 Grade Stainless Steel',
        thumbnailUrl: '/images/products/BS-7813-0615.jpg',
        price: 6.37,
        link: 'https://www.awrsolutions.com.au/products/blacketch-angle-connector-m6-x-15mm-right-hand-thread-316-stainless'
    },
    'SS-7813R-0615': {
        title: 'SS-7813R-0615',
        subtitle: 'Angle Connector M6 x 15mm Right Hand Thread - 316 Grade Stainless Steel',
        thumbnailUrl: '/images/products/SS-7813-0615.jpg',
        price: 5.85,
        link: 'https://www.awrsolutions.com.au/products/angle-connector-m6-x-15mm-right-hand-thread-316-stainless'
    },
    'SS-7813L-0615': {
        title: 'SS-7813L-0615',
        subtitle: 'Angle Connector M6 x 15mm Left Hand Thread - 316 Grade Stainless Steel',
        thumbnailUrl: '/images/products/SS-7813-0615.jpg',
        price: 5.85,
        link: 'https://www.awrsolutions.com.au/products/angle-connector-m6-x-15mm-left-hand-thread-316-stainless'
    },
    // #endregion
    // #region Metal systems
    // Rig Fork Nutserts
    'WBS-RFNS': {
        title: 'WBS-RFNS',
        subtitle: 'Bright Finish Factory Swaged Wire Balustrade - Rig Fork System with Nutserts - Suits Metal Posts',
        thumbnailUrl: '/images/products/WBS-RFNS.jpg',
        price: 11.93,
        link: 'https://www.awrsolutions.com.au/products/bright-finish-factory-swaged-wire-balustrade-rig-f-with-nutserts'
    },
    'WBSB-RFNS': {
        title: 'WBSB-RFNS',
        subtitle: 'BlackEtch Factory Swaged Wire Balustrade - Rig Fork System with Nutserts - Suits Metal Posts',
        thumbnailUrl: '/images/products/WBSB-RFNS.jpg',
        price: 14.73,
        link: 'https://www.awrsolutions.com.au/products/blacketch-factory-swaged-wire-balustrade-rig-fork-with-nutserts'
    },
    // Toggle Lock
    'WBS-TLS': {
        title: 'WBS-TLS',
        subtitle: 'Bright Finish Factory Swaged Wire Balustrade - Toggle Lock System - Suits Metal Posts',
        thumbnailUrl: '/images/products/WBS-TLS.jpg',
        price: 12.08,
        link: 'https://www.awrsolutions.com.au/wire-balustrade/wire-balustrade-pre-made-systems-ready-to-install/to-suit-metal-posts-pre-swaged/bright-finish-factory-swaged-wire-balustrade-toggl'
    },
    'WBSB-TLS': {
        title: 'WBSB-TLS',
        subtitle: 'BlackEtch Factory Swaged Wire Balustrade - Toggle Lock System - Suits Metal Posts',
        thumbnailUrl: '/images/products/WBSB-TLS.jpg',
        price: 14.06,
        link: 'https://www.awrsolutions.com.au/wire-balustrade/wire-balustrade-pre-made-systems-ready-to-install/blacketch-factory-swaged-wire-balustrade-toggle-lo'
    },
    // Metal Insert
    'WBS-MIS': {
        title: 'WBS-MIS',
        subtitle: 'Bright Finish Factory Swaged Wire Balustrade - Metal Insert System - Suits Metal Posts',
        thumbnailUrl: '/images/products/WBS-MIS.jpg',
        price: 4.84,
        link: 'https://www.awrsolutions.com.au/products/bright-finish-factory-swaged-wire-balustrade-metal-insert-system'
    },
    'WBSB-MIS': {
        title: 'WBSB-MIS',
        subtitle: 'Wire Balustrades Metal Insert System black, Black Wire Balustrades, Metal Insert System black',
        thumbnailUrl: '/images/products/WBSB-MIS.jpg',
        price: 6.29,
        link: 'https://www.awrsolutions.com.au/products/blacketch-factory-swaged-wire-balustrade-metal-ins-system'
    },
    // Rig Fork Saddles
    'WBS-RFSAD-M': {
        title: 'WBS-RFSAD-M',
        subtitle: 'Wire Balustrades Rig Fork System with Saddles',
        thumbnailUrl: '/images/products/WBS-RFSAD-M.jpg',
        price: 8.24,
        link: 'https://www.awrsolutions.com.au/products/bright-finish-factory-swaged-wire-balustrade-rig-fork-system-with-saddles-suits-metal-posts'
    },
    'WBSB-RFSAD-M': {
        title: 'WBSB-RFSAD-M',
        subtitle: 'Wire Balustrades Rig Fork System with Saddles Black',
        thumbnailUrl: '/images/products/WBSB-RFSAD-M.jpg',
        price: 10.22,
        link: 'https://www.awrsolutions.com.au/products/blacketch-factory-swaged-wire-balustrade-rig-fork-suits-metal-posts'
    },
    // #endregion
    // #region Intermediate posts
    'ALP-INT50960-BL': {
        title: 'ALP-INT50960-BL',
        subtitle: 'Heavy Duty Wire Balustrade INTERMEDIATE Post 960mm High 11 x 8mm Holes (2 sides at 180 degrees) - Protexture Black',
        thumbnailUrl: '/images/products/ALP-INT50960-BL.jpg',
        price: 126.96,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-intermediate-post-960mm-11x8mm'
    },
    'SSRP-INT50960F-SF': {
        title: 'SSRP-INT50960F-SF',
        subtitle: 'Round Intermediate Post 50.8mm x 1.6mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 84.95,
        link: 'https://www.awrsolutions.com.au/products/round-intermediate-post-with-straight-fixed-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSRP-INT50960R-SF': {
        title: 'SSRP-INT50960R-SF',
        subtitle: 'Round Intermediate Post 50.8mm x 1.6mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 84.95,
        link: 'https://www.awrsolutions.com.au/products/round-intermediate-post-with-straight-fixed-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSRP-INT50960F-MP': {
        title: 'SSRP-INT50960F-MP',
        subtitle: 'Round Intermediate Post 50.8mm x 1.6mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 99.05,
        link: 'https://www.awrsolutions.com.au/products/round-intermediate-post-with-straight-fixed-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSRP-INT50960R-MP': {
        title: 'SSRP-INT50960R-MP',
        subtitle: 'Round Intermediate Post 50.8mm x 1.6mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 99.05,
        link: 'https://www.awrsolutions.com.au/products/round-intermediate-post-with-straight-fixed-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-INT50960F-SF': {
        title: 'SSSP-INT50960F-SF',
        subtitle: 'Square Intermediate Post 50.8mm x 1.6mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 105.95,
        link: 'https://www.awrsolutions.com.au/products/square-intermediate-post-with-straight-fixed-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSSP-INT50960R-SF': {
        title: 'SSSP-INT50960R-SF',
        subtitle: 'Square Intermediate Post 50.8mm x 1.6mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 105.95,
        link: 'https://www.awrsolutions.com.au/products/square-intermediate-post-with-straight-fixed-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSSP-INT50960F-MP': {
        title: 'SSSP-INT50960F-MP',
        subtitle: 'Square Intermediate Post 50.8mm x 1.6mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 124.55,
        link: 'https://www.awrsolutions.com.au/products/square-intermediate-post-with-straight-fixed-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-INT50960R-MP': {
        title: 'SSSP-INT50960R-MP',
        subtitle: 'Square Intermediate Post 50.8mm x 1.6mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 124.55,
        link: 'https://www.awrsolutions.com.au/products/square-intermediate-post-with-straight-fixed-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    // #endregion
    // #region Corner posts
    'ALP-CNR50960-BL': {
        title: 'ALP-CNR50960-BL',
        subtitle: 'Heavy Duty Wire Balustrade CORNER Post 960mm High 11 x 9mm Holes (2 sides at 90 degrees) - Protexture Black',
        thumbnailUrl: '/images/products/ALP-CNR50960-BL.jpg',
        price: 129.8,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-corner-post-960mm-high'
    },
    'SSRP-CNR50960F-SF': {
        title: 'SSRP-CNR50960F-SF',
        subtitle: 'Round Corner Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 130.75,
        link: 'https://www.awrsolutions.com.au/products/round-corner-post-with-corner-fixed-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSRP-CNR50960R-SF': {
        title: 'SSRP-CNR50960R-SF',
        subtitle: 'Round Corner Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 130.75,
        link: 'https://www.awrsolutions.com.au/products/round-corner-post-with-corner-fixed-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSRP-CNR50960F-MP': {
        title: 'SSRP-CNR50960F-MP',
        subtitle: 'Round Corner Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 150.75,
        link: 'https://www.awrsolutions.com.au/products/round-corner-post-with-corner-fixed-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSRP-CNR50960R-MP': {
        title: 'SSRP-CNR50960R-MP',
        subtitle: 'Round Corner Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 150.75,
        link: 'https://www.awrsolutions.com.au/products/round-corner-post-with-corner-fixed-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-CNR50960F-SF': {
        title: 'SSSP-CNR50960F-SF',
        subtitle: 'Square Corner Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 152.75,
        link: 'https://www.awrsolutions.com.au/products/square-corner-post-with-corner-fixed-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSSP-CNR50960R-SF': {
        title: 'SSSP-CNR50960R-SF',
        subtitle: 'Square Corner Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 152.75,
        link: 'https://www.awrsolutions.com.au/products/square-corner-post-with-corner-fixed-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSSP-CNR50960F-MP': {
        title: 'SSSP-CNR50960F-MP',
        subtitle: 'Square Corner Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 179.25,
        link: 'https://www.awrsolutions.com.au/products/square-corner-post-with-corner-fixed-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-CNR50960R-MP': {
        title: 'SSSP-CNR50960R-MP',
        subtitle: 'Square Corner Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 179.25,
        link: 'https://www.awrsolutions.com.au/products/square-corner-post-with-corner-fixed-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    // #endregion
    // #region End posts
    'ALP-END50960-BL': {
        title: 'ALP-END50960-BL',
        subtitle: 'Heavy Duty Wire Balustrade END Post 960mm High 11 x 9mm Holes - Protexture Black',
        thumbnailUrl: '/images/products/ALP-END50960-BL.jpg',
        price: 122.93,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-end-post-960mm-high-11'
    },
    'SSRP-END50960F-SF': {
        title: 'SSRP-END50960F-SF',
        subtitle: 'Round End Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 125.95,
        link: 'https://www.awrsolutions.com.au/products/round-end-post-with-straight-fixed-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSRP-END50960R-SF': {
        title: 'SSRP-END50960R-SF',
        subtitle: 'Round End Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 125.95,
        link: 'https://www.awrsolutions.com.au/products/round-end-post-with-straight-fixed-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSRP-END50960F-MP': {
        title: 'SSRP-END50960F-MP',
        subtitle: 'Round End Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 146.05,
        link: 'https://www.awrsolutions.com.au/products/round-end-post-with-straight-fixed-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSRP-END50960R-MP': {
        title: 'SSRP-END50960R-MP',
        subtitle: 'Round End Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 146.05,
        link: 'https://www.awrsolutions.com.au/products/round-end-post-with-straight-fixed-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-END50960F-SF': {
        title: 'SSSP-END50960F-SF',
        subtitle: 'Square End Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 149.45,
        link: 'https://www.awrsolutions.com.au/products/square-end-post-with-straight-fixed-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSSP-END50960R-SF': {
        title: 'SSSP-END50960R-SF',
        subtitle: 'Square End Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 149.45,
        link: 'https://www.awrsolutions.com.au/products/square-end-post-with-straight-fixed-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSSP-END50960F-MP': {
        title: 'SSSP-END50960F-MP',
        subtitle: 'Square End Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 174.55,
        link: 'https://www.awrsolutions.com.au/products/square-end-post-with-straight-fixed-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-END50960R-MP': {
        title: 'SSSP-END50960R-MP',
        subtitle: 'Square End Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 174.55,
        link: 'https://www.awrsolutions.com.au/products/square-end-post-with-straight-fixed-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    // #endregion
    // #region Right Sloped corner posts
    'ALP-STPR50960-BL': {
        title: 'ALP-STPR50960-BL',
        subtitle: 'Heavy Duty Wire Balustrade CNR STAIR - RIGHT post 960m High with 11 x 9mm Holes and 10 x 9mm Holes - Protexture Black',
        thumbnailUrl: '/images/products/ALP-INT50ANG-BL.jpg',
        price: 157.93,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-stair-right-hand-corner-post-960mm'
    },
    'SSRP-STPR50960F-SF': {
        title: 'SSRP-STPR50960F-SF',
        subtitle: 'Round Stair Post Right 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 147.75,
        link: 'https://www.awrsolutions.com.au/products/round-stair-right-hand-post-with-stair-corner-short-right-hand-saddle-flat-handrail-satin'
    },
    'SSRP-STPR50960R-SF': {
        title: 'SSRP-STPR50960R-SF',
        subtitle: 'Round Stair Post Right 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 147.75,
        link: 'https://www.awrsolutions.com.au/products/round-stair-right-hand-post-with-stair-corner-short-right-hand-saddle-round-handrail-satin'
    },
    'SSRP-STPR50960F-MP': {
        title: 'SSRP-STPR50960F-MP',
        subtitle: 'Round Stair Post Right 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 168.05,
        link: 'https://www.awrsolutions.com.au/products/round-stair-right-hand-post-with-stair-corner-short-right-hand-saddle-flat-handrail-mirror'
    },
    'SSRP-STPR50960R-MP': {
        title: 'SSRP-STPR50960R-MP',
        subtitle: 'Round Stair Post Right 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 168.05,
        link: 'https://www.awrsolutions.com.au/products/round-stair-right-hand-post-with-stair-corner-short-right-hand-saddle-round-handrail-mirror'
    },
    'SSSP-STPR50960F-SF': {
        title: 'SSSP-STPR50960F-SF',
        subtitle: 'Square Stair Post Right 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 171.25,
        link: 'https://www.awrsolutions.com.au/products/square-stair-right-hand-post-with-stair-corner-short-right-hand-saddle-flat-handrail-satin'
    },
    'SSSP-STPR50960R-SF': {
        title: 'SSSP-STPR50960R-SF',
        subtitle: 'Square Stair Post Right 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 171.25,
        link: 'https://www.awrsolutions.com.au/products/square-stair-right-hand-post-with-stair-corner-short-right-hand-saddle-round-handrail-satin'
    },
    'SSSP-STPR50960F-MP': {
        title: 'SSSP-STPR50960F-MP',
        subtitle: 'Square Stair Post Right 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 196.55,
        link: 'https://www.awrsolutions.com.au/products/square-stair-right-hand-post-with-stair-corner-short-right-hand-saddle-flat-handrail-mirror'
    },
    'SSSP-STPR50960R-MP': {
        title: 'SSSP-STPR50960R-MP',
        subtitle: 'Square Stair Post Right 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 196.55,
        link: 'https://www.awrsolutions.com.au/products/square-stair-right-hand-post-with-stair-corner-short-right-hand-saddle-round-handrail-mirror'
    },
    // #endregion
    // #region Left Sloped corner posts
    'ALP-STPL50960-BL': {
        title: 'ALP-STPL50960-BL',
        subtitle: 'Heavy Duty Wire Balustrade CNR STAIR - LEFT post 960m High with 11 x 9mm Holes and 10 x 9mm Holes - Protexture Black',
        thumbnailUrl: '/images/products/ALP-INT50ANG-BL.jpg',
        price: 157.93,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-stair-left-hand-corner'
    },
    'SSRP-STPL50960F-SF': {
        title: 'SSRP-STPL50960F-SF',
        subtitle: 'Round Stair Post Left 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 147.75,
        link: 'https://www.awrsolutions.com.au/products/round-stair-left-hand-post-with-stair-corner-short-left-hand-saddle-flat-handrail-960mm-satin'
    },
    'SSRP-STPL50960R-SF': {
        title: 'SSRP-STPL50960R-SF',
        subtitle: 'Round Stair Post Left 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 147.75,
        link: 'https://www.awrsolutions.com.au/products/round-stair-left-hand-post-with-stair-corner-short-left-hand-saddle-round-handrail-960mm-satin'
    },
    'SSRP-STPL50960F-MP': {
        title: 'SSRP-STPL50960F-MP',
        subtitle: 'Round Stair Post Left 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 168.05,
        link: 'https://www.awrsolutions.com.au/products/round-stair-left-hand-post-with-stair-corner-short-left-hand-saddle-flat-handrail-960mm-mirror'
    },
    'SSRP-STPL50960R-MP': {
        title: 'SSRP-STPL50960R-MP',
        subtitle: 'Round Stair Post Left 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 168.05,
        link: 'https://www.awrsolutions.com.au/products/round-stair-left-hand-post-with-stair-corner-short-left-hand-saddle-round-handrail-mirror'
    },
    'SSSP-STPL50960F-SF': {
        title: 'SSSP-STPL50960F-SF',
        subtitle: 'Square Stair Post Left 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 171.25,
        link: 'https://www.awrsolutions.com.au/products/square-stair-left-hand-post-with-stair-corner-short-left-hand-saddle-flat-handrail-960mm-satin'
    },
    'SSSP-STPL50960R-SF': {
        title: 'SSSP-STPL50960R-SF',
        subtitle: 'Square Stair Post Left 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 171.25,
        link: 'https://www.awrsolutions.com.au/products/square-stair-left-hand-post-with-stair-corner-short-left-hand-saddle-round-handrail-satin'
    },
    'SSSP-STPL50960F-MP': {
        title: 'SSSP-STPL50960F-MP',
        subtitle: 'Square Stair Post Left 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 196.55,
        link: 'https://www.awrsolutions.com.au/products/square-stair-left-hand-post-with-stair-corner-short-left-hand-saddle-flat-handrail-mirror'
    },
    'SSSP-STPL50960R-MP': {
        title: 'SSSP-STPL50960R-MP',
        subtitle: 'Square Stair Post Left 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 196.55,
        link: 'https://www.awrsolutions.com.au/products/square-stair-left-hand-post-with-stair-corner-short-left-hand-saddle-round-handrail-mirror'
    },
    // #endregion
    // #region Flat Stairs Straight posts
    'ALP-STPMID50960-BL': {
        title: 'ALP-STPMID50960-BL',
        subtitle: 'Heavy Duty Wire Balustrade STAIR MID Post 960mm High 11 x 9mm Holes one side up to 11 x 9mm holes other side - 6061 T6 Aluminium - Protexture Black',
        thumbnailUrl: '/images/products/ALP-INT50ANG-BL.jpg',
        price: 157.93,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-stair-mid-post-black'
    },
    'SSRP-STMID50960F-SF': {
        title: 'SSRP-STMID50960F-SF',
        subtitle: 'Round Stair Mid Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 146.1,
        link: 'https://www.awrsolutions.com.au/products/round-stair-mid-post-with-short-single-sided-fixed-saddle-flat-handrail-960mm-316-satin'
    },
    'SSRP-STMID50960R-SF': {
        title: 'SSRP-STMID50960R-SF',
        subtitle: 'Round Stair Mid Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 146.1,
        link: 'https://www.awrsolutions.com.au/products/round-stair-mid-post-with-short-single-sided-fixed-saddle-round-handrail-960mm-316-satin'
    },
    'SSRP-STMID50960F-MP': {
        title: 'SSRP-STMID50960F-MP',
        subtitle: 'Round Stair Mid Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 166.35,
        link: 'https://www.awrsolutions.com.au/products/round-stair-mid-post-with-short-single-sided-fixed-saddle-flat-handrail-960mm-316-mirror'
    },
    'SSRP-STMID50960R-MP': {
        title: 'SSRP-STMID50960R-MP',
        subtitle: 'Round Stair Mid Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 166.35,
        link: 'https://www.awrsolutions.com.au/products/round-stair-mid-post-with-short-single-sided-fixed-saddle-round-handrail-960mm-316-mirror'
    },
    'SSSP-STMID50960F-SF': {
        title: 'SSSP-STMID50960F-SF',
        subtitle: 'Square Stair Mid Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 169.6,
        link: 'https://www.awrsolutions.com.au/products/square-stair-mid-post-with-short-single-sided-fixed-saddle-flat-handrail-960mm-316-satin'
    },
    'SSSP-STMID50960R-SF': {
        title: 'SSSP-STMID50960R-SF',
        subtitle: 'Square Stair Mid Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 169.6,
        link: 'https://www.awrsolutions.com.au/products/square-stair-mid-post-with-short-single-sided-fixed-saddle-round-handrail-960mm-316-satin'
    },
    'SSSP-STMID50960F-MP': {
        title: 'SSSP-STMID50960F-MP',
        subtitle: 'Square Stair Mid Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 194.85,
        link: 'https://www.awrsolutions.com.au/products/square-stair-mid-post-with-short-single-sided-fixed-saddle-flat-handrail-960mm-316-mirror'
    },
    'SSSP-STMID50960R-MP': {
        title: 'SSSP-STMID50960R-MP',
        subtitle: 'Square Stair Mid Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 194.85,
        link: 'https://www.awrsolutions.com.au/products/square-stair-mid-post-with-short-single-sided-fixed-saddle-round-handrail-960mm-316-mirror'
    },
    // #endregion
    // #region Angled end posts
    'ALP-END50ANG-BL': {
        title: 'ALP-END50ANG-BL',
        subtitle: 'Heavy Duty Wire Balustrade END STAIR post 960m High with 11 x 9mm Holes - Protexture Black',
        thumbnailUrl: '/images/products/ALP-END50ANG-BL.jpg',
        price: 144.91,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-end-angled-960m-high-wi-protexture-black'
    },
    'SSRP-STEND50960F-SF': {
        title: 'SSRP-STEND50960F-SF',
        subtitle: 'Round Stair End Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 124.4,
        link: 'https://www.awrsolutions.com.au/products/round-stair-end-post-with-straight-adjustable-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSRP-STEND50960R-SF': {
        title: 'SSRP-STEND50960R-SF',
        subtitle: 'Round Stair End Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 124.4,
        link: 'https://www.awrsolutions.com.au/products/round-stair-end-post-with-straight-adjustable-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSRP-STEND50960F-MP': {
        title: 'SSRP-STEND50960F-MP',
        subtitle: 'Round Stair End Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 144.4,
        link: 'https://www.awrsolutions.com.au/products/round-stair-end-post-with-straight-adjustable-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSRP-STEND50960R-MP': {
        title: 'SSRP-STEND50960R-MP',
        subtitle: 'Round Stair End Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 144.4,
        link: 'https://www.awrsolutions.com.au/products/round-stair-end-post-with-straight-adjustable-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-STEND50960F-SF': {
        title: 'SSSP-STEND50960F-SF',
        subtitle: 'Square Stair End Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 144.9,
        link: 'https://www.awrsolutions.com.au/products/square-stair-end-post-with-straight-adjustable-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSSP-STEND50960R-SF': {
        title: 'SSSP-STEND50960R-SF',
        subtitle: 'Square Stair End Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 144.9,
        link: 'https://www.awrsolutions.com.au/products/square-stair-end-post-with-straight-adjustable-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSSP-STEND50960F-MP': {
        title: 'SSSP-STEND50960F-MP',
        subtitle: 'Square Stair End Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 171.4,
        link: 'https://www.awrsolutions.com.au/products/square-stair-end-post-with-straight-adjustable-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-STEND50960R-MP': {
        title: 'SSSP-STEND50960R-MP',
        subtitle: 'Square Stair End Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 171.4,
        link: 'https://www.awrsolutions.com.au/products/square-stair-end-post-with-straight-adjustable-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    // #endregion
    // #region Angled intermediate posts
    'ALP-INT50ANG-BL': {
        title: 'ALP-INT50ANG-BL',
        subtitle: 'Heavy Duty Wire Balustrade INTERMEDIATE ANGLED Post 960mm High with 10 x drilled Holes (2 sides at 180 degrees) - Protexture Black',
        thumbnailUrl: '/images/products/ALP-INT50ANG-BL.jpg',
        price: 155.66,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-intermediate-angled-pos-protexture-black'
    },
    'SSRP-STPI50960F-SF': {
        title: 'SSRP-STPI50960F-SF',
        subtitle: 'Round Stair Intermediate Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 124.4,
        link: 'https://www.awrsolutions.com.au/products/round-stair-intermediate-post-with-straight-adjustable-saddle-flat-handrail-960mm-316-satin'
    },
    'SSRP-STPI50960R-SF': {
        title: 'SSRP-STPI50960R-SF',
        subtitle: 'Round Stair Intermediate Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 124.4,
        link: 'https://www.awrsolutions.com.au/products/round-stair-intermediate-post-with-straight-adjustable-saddle-round-handrail-960mm-316-satin'
    },
    'SSRP-STPI50960F-MP': {
        title: 'SSRP-STPI50960F-MP',
        subtitle: 'Round Stair Intermediate Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 144.9,
        link: 'https://www.awrsolutions.com.au/products/round-stair-intermediate-post-with-straight-adjustable-saddle-flat-handrail-960mm-316-mirror'
    },
    'SSRP-STPI50960R-MP': {
        title: 'SSRP-STPI50960R-MP',
        subtitle: 'Round Stair Intermediate Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 144.9,
        link: 'https://www.awrsolutions.com.au/products/round-stair-intermediate-post-with-straight-adjustable-saddle-round-handrail-960mm-316-mirror'
    },
    'SSSP-STPI50960F-SF': {
        title: 'SSSP-STPI50960F-SF',
        subtitle: 'Square Stair Intermediate Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 143.4,
        link: 'https://www.awrsolutions.com.au/products/square-stair-intermediate-post-with-straight-adjustable-saddle-flat-handrail-960mm-316-satin'
    },
    'SSSP-STPI50960R-SF': {
        title: 'SSSP-STPI50960R-SF',
        subtitle: 'Square Stair Intermediate Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 143.4,
        link: 'https://www.awrsolutions.com.au/products/square-stair-intermediate-post-with-straight-adjustable-saddle-round-handrail-960mm-316-satin'
    },
    'SSSP-STPI50960F-MP': {
        title: 'SSSP-STPI50960F-MP',
        subtitle: 'Square Stair Intermediate Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 170.4,
        link: 'https://www.awrsolutions.com.au/products/square-stair-intermediate-post-with-straight-adjustable-saddle-flat-handrail-960mm-316-mirror'
    },
    'SSSP-STPI50960R-MP': {
        title: 'SSSP-STPI50960R-MP',
        subtitle: 'Square Stair Intermediate Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 170.4,
        link: 'https://www.awrsolutions.com.au/products/square-stair-intermediate-post-with-straight-adjustable-saddle-round-handrail-960mm-316-mirror'
    },
    // #endregion
    // #region Thin intermediate posts
    'INT5010A-B': {
        title: 'INT5010A-B',
        subtitle: 'Intermediate Post 50mm x 10mm - 960mm high. Predrilled with 11 x 8mm holes at 80mm spacing - Aluminium - Protexture Black',
        thumbnailUrl: '/images/products/INT5010A-B.jpg',
        price: 69.5,
        link: 'https://www.awrsolutions.com.au/products/intermediate-post-50mm-x-10mm-960mm-int5010a-b'
    },
    'INT5010-MP': {
        title: 'INT5010-MP',
        subtitle: 'Intermediate Post 50mm x 10mm - 960mm high. Predrilled with 11 x 8mm holes at 80mm spacing. 316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/INT5010-MP.jpg',
        price: 97.5,
        link: 'https://www.awrsolutions.com.au/products/intermediate-post-50mm-x-10mm-960mm-high-predrill-mirror-polish'
    },
    'INT5010-SF': {
        title: 'INT5010-SF',
        subtitle: 'Intermediate Post 50mm x 10mm - 960mm high. Predrilled with 11 x 8mm holes at 80mm spacing. 316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/INT5010-SF.jpg',
        price: 88.5,
        link: 'https://www.awrsolutions.com.au/products/intermediate-post-50mm-x-10mm-960mm-int5010-sf'
    },
    // #endregion
    // $region Mid Posts
    'SSSP-MID50960F-SF': {
        title: 'SSSP-MID50960F-SF',
        subtitle: 'Square Mid Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 171.6,
        link: 'https://www.awrsolutions.com.au/products/square-mid-post-with-long-single-sided-fixed-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSSP-MID50960F-MP': {
        title: 'SSSP-MID50960F-MP',
        subtitle: 'Square Mid Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 196.85,
        link: 'https://www.awrsolutions.com.au/products/square-mid-post-with-long-single-sided-fixed-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSSP-MID50960R-SF': {
        title: 'SSSP-MID50960R-SF',
        subtitle: 'Square Mid Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSSP-SF.jpg',
        price: 171.6,
        link: 'https://www.awrsolutions.com.au/products/square-mid-post-with-long-single-sided-fixed-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSSP-MID50960R-MP': {
        title: 'SSSP-MID50960R-MP',
        subtitle: 'Square Mid Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSSP-MP.jpg',
        price: 196.85,
        link: 'https://www.awrsolutions.com.au/products/square-mid-post-with-long-single-sided-fixed-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    'SSRP-MID50960F-SF': {
        title: 'SSRP-MID50960F-SF',
        subtitle: 'Round Mid Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 148.1,
        link: 'https://www.awrsolutions.com.au/products/round-mid-post-with-long-single-sided-fixed-saddle-flat-handrail-960mm-316-stainless-satin'
    },
    'SSRP-MID50960F-MP': {
        title: 'SSRP-MID50960F-MP',
        subtitle: 'Round Mid Post 50.8mm x 3.0mm - 960mm High Suits Flat Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 168.35,
        link: 'https://www.awrsolutions.com.au/products/round-mid-post-with-long-single-sided-fixed-saddle-flat-handrail-960mm-316-stainless-mirror'
    },
    'SSRP-MID50960R-SF': {
        title: 'SSRP-MID50960R-SF',
        subtitle: 'Round Mid Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Satin Finish',
        thumbnailUrl: '/images/products/SSRP-SF.jpg',
        price: 148.1,
        link: 'https://www.awrsolutions.com.au/products/round-mid-post-with-long-single-sided-fixed-saddle-round-handrail-960mm-316-stainless-satin'
    },
    'SSRP-MID50960R-MP': {
        title: 'SSRP-MID50960R-MP',
        subtitle: 'Round Mid Post 50.8mm x 3.0mm - 960mm High Suits Round Handrail316 Grade Stainless Steel Mirror Polish',
        thumbnailUrl: '/images/products/SSRP-MP.jpg',
        price: 168.35,
        link: 'https://www.awrsolutions.com.au/products/round-mid-post-with-long-single-sided-fixed-saddle-round-handrail-960mm-316-stainless-mirror'
    },
    'ALP-MID50960-BL': {
        title: 'ALP-MID50960-BL',
        subtitle: 'Heavy Duty Wire Balustrade MID TERMINATION Post 960mm High 11 x 9mm Holes (2 sides at 180 degrees) - Protexture Black',
        thumbnailUrl: '/images/products/ALP-INT50ANG-BL.jpg',
        price: 129.8,
        link: 'https://www.awrsolutions.com.au/products/heavy-duty-wire-balustrade-mid-termination-post-960mm-protexture-black'
    },
    // #endregion
    // #region Handrails
    // Round
    'RT-S-316-2-MTR': {
        title: 'RT-S-316-2-MTR',
        subtitle: 'Round Tube 50.8mm x 1.6mm 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/RT-S-316-2-MTR.jpg',
        price: 33.76,
        link: 'https://www.awrsolutions.com.au/products/round-tube-316-stainless-satin'
    },
    'RT-P-316-2-MTR': {
        title: 'RT-P-316-2-MTR',
        subtitle: 'Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/RT-P-316-2-MTR.jpg',
        price: 43.31,
        link: 'https://www.awrsolutions.com.au/products/round-tube-50-8mm-x-1-6mm-wall-316-stainless-mirror-per-metre'
    },
    'HR-S-2004E': {
        title: 'HR-S-2004E',
        subtitle: 'In-line Flush Joiner to suit 2" (50.8mm) x 1.5mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-2004E.jpg',
        price: 9.2,
        link: 'https://www.awrsolutions.com.au/products/in-line-flush-joiner-suits-50-8mm-x-1-6mm-round-tube-316-stainless-satin'
    },
    'HR-2004E': {
        title: 'HR-2004E',
        subtitle: 'In-Line Flush Joiner to suit 1.5mm Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-2004E.jpg',
        price: 9.2,
        link: 'https://www.awrsolutions.com.au/products/in-line-flush-joiner-suits-1-6mm-round-tube-316-stainless-mirror'
    },
    'HR-S-20350E': {
        title: 'HR-S-20350E',
        subtitle: 'Adjustable Joiner to suit 50.8mm x 1.6mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-20350E.jpg',
        price: 45.95,
        link: 'https://www.awrsolutions.com.au/products/round-adjustable-joiner-to-suit-2-50-8mm-x-1-6mm-round-tube-316-grade-stainless-steel-satin-finish'
    },
    'HR-S-20351E': {
        title: 'HR-S-20351E',
        subtitle: 'Stair Corner Adjustable Joiner to suit 50.8mm x 1.6mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-20351E.jpg',
        price: 67.85,
        link: 'https://www.awrsolutions.com.au/products/round-stair-90-degree-adjustable-joiner-to-suit-2-50-8mm-x-1-6mm-round-tube-316-grade-stainless-steel-satin-finish'
    },
    'HR-20350E': {
        title: 'HR-20350E',
        subtitle: 'Adjustable Joiner to suit 50.8mm x 1.6mm Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-20350E.jpg',
        price: 48.02,
        link: 'https://www.awrsolutions.com.au/products/round-adjustable-joiner-to-suit-2-50-8mm-x-1-6mm-round-tube-316-grade-stainless-steel-mirror-polish'
    },
    'HR-20351E': {
        title: 'HR-20351E',
        subtitle: 'Stair Corner Adjustable Joiner to suit 50.8mm x 1.6mm Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-20351E.jpg',
        price: 71.31,
        link: 'https://www.awrsolutions.com.au/products/round-stair-90-degree-adjustable-joiner-to-suit-2-50-8mm-x-1-6mm-round-tube-316-grade-stainless-steel-mirror-polish'
    },
    // Square
    'ST-S-316-2-MTR': {
        title: 'ST-S-316-2-MTR',
        subtitle: 'Square Tube 50.8mm x 1.6mm 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/ST-S-316-2-MTR.jpg',
        price: 42.65,
        link: 'https://www.awrsolutions.com.au/products/square-tube-50-8mm-x-1-6mm-wall-316-stainless-satin'
    },
    'ST-P-316-2-MTR': {
        title: 'ST-P-316-2-MTR',
        subtitle: 'Square Tube 50.8mm x 1.6mm 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/ST-P-316-2-MTR.jpg',
        price: 65.62,
        link: 'https://www.awrsolutions.com.au/products/square-tube-50-8mm-x-1-6mm-wall-316-stainless-mirror'
    },
    'HR-SM-2002': {
        title: 'HR-SM-2002',
        subtitle: '90 Degree Elbow Joiner to suit 50.8mm x 1.6mm Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-SM-2002.jpg',
        price: 26.18,
        link: 'https://www.awrsolutions.com.au/products/90-degree-elbow-suits-50-8mm-x-1-6mm-square-tube-316-stainless-mirror'
    },
    'HR-SS-2004': {
        title: 'HR-SS-2004',
        subtitle: 'In-line Flush Joiner to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Satin Finish',
        thumbnailUrl: '/images/products/HR-SS-2004.jpg',
        price: 10.5,
        link: 'https://www.awrsolutions.com.au/products/in-line-flush-joiner-suits-50-8mm-x-1-6mm-square-tube-316-stainless-satin'
    },
    'HR-SM-2004': {
        title: 'HR-SM-2004',
        subtitle: 'In-line Flush Joiner to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Mirror Polish',
        thumbnailUrl: '/images/products/HR-SM-2004.jpg',
        price: 11.5,
        link: 'https://www.awrsolutions.com.au/products/in-line-flush-joiner-suits-50-8mm-x-1-6mm-square-tube-316-stainless-mirror'
    },
    'HR-SS-20350E': {
        title: 'HR-SS-20350E',
        subtitle: 'Adjustable Joiner to suit 50.8mm x 1.6mm Square Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-SS-20350E.jpg',
        price: 62.15,
        link: 'https://www.awrsolutions.com.au/products/square-adjustable-joiner-to-suit-2-50-8mm-x-1-6mm-square-tube-316-grade-stainless-steel-satin-finish'
    },
    'HR-SM-20350E': {
        title: 'HR-SM-20350E',
        subtitle: 'Adjustable Joiner to suit 50.8mm x 1.6mm Square Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-SM-20350E.jpg',
        price: 64.27,
        link: 'https://www.awrsolutions.com.au/products/square-adjustable-joiner-to-suit-2-50-8mm-x-1-6mm-square-tube-316-grade-stainless-steel-mirror-polish'
    },
    'HR-SS-20351E': {
        title: 'HR-SS-20351E',
        subtitle: 'Stair Corner Adjustable Joiner to suit 50.8mm x 1.6mm Square Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-SS-20351E.jpg',
        price: 83.59,
        link: 'https://www.awrsolutions.com.au/products/square-stair-90-degree-adjustable-joiner-to-suit-2-50-8mm-x-1-6mm-square-tube-316-grade-stainless-steel-satin-finish'
    },
    'HR-SM-20351E': {
        title: 'HR-SM-20351E',
        subtitle: 'Stair Corner Adjustable Joiner to suit 50.8mm x 1.6mm Square Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-SM-20351E.jpg',
        price: 87.05,
        link: 'https://www.awrsolutions.com.au/products/square-stair-90-degree-adjustable-joiner-to-suit-2-50-8mm-x-1-6mm-square-tube-316-grade-stainless-steel-mirror-polish'
    },
    // #endregion
    // #region Handrail Ends
    // Round
    'HR-S-2002E': {
        title: 'HR-S-2002E',
        subtitle: '90 Degree Elbow Joiner to suit 2" (50.8mm) x 1.5mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-2002E.jpg',
        price: 18.85,
        link: 'https://www.awrsolutions.com.au/products/90-degree-elbow-joiner-suits-50-8mm-x-1-6mm-round-tube-316-stainless-satin'
    },
    'HR-2002E': {
        title: 'HR-2002E',
        subtitle: '90 Degree Elbow to Suit 1.5mm Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-2002E.jpg',
        price: 18.85,
        link: 'https://www.awrsolutions.com.au/products/90-degree-elbow-suits-1-6mm-round-tube-316-stainless-mirror'
    },
    'HR-2014A': {
        title: 'HR-2014A',
        subtitle: 'Oblong Base Plate/ Flange 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-2014A.jpg',
        price: 15.17,
        link: 'https://www.awrsolutions.com.au/products/oblong-base-plate-316-stainless-mirror'
    },
    'HR-S-2014A': {
        title: 'HR-S-2014A',
        subtitle: 'Oblong Flange 2 Hole to suit 2" (50.8mm) x 1.5mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-2014A.jpg',
        price: 14.96,
        link: 'https://www.awrsolutions.com.au/products/oblong-flange-2-hole-suits-1-6mm-round-tube-316-stainless-satin'
    },
    'HR-2016A': {
        title: 'HR-2016A',
        subtitle: 'Post Round Base Plate/ Flange 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-2016A.jpg',
        price: 16.15,
        link: 'https://www.awrsolutions.com.au/products/post-round-base-plate-316-stainless-mirror'
    },
    'HR-S-2016A': {
        title: 'HR-S-2016A',
        subtitle: 'Round Base Flange 3 Screw Hole to suit 2" (50.8mm) x 1.5mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-2016A.jpg',
        price: 15.71,
        link: 'https://www.awrsolutions.com.au/products/round-base-flange-3-screw-hole-to-suit-2-50-8mm-x'
    },
    'HR-2017A': {
        title: 'HR-2017A',
        subtitle: 'Radiused End Cap Self Grip to Suit 1.5mm Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-2017A.jpg',
        price: 7.16,
        link: 'https://www.awrsolutions.com.au/products/radiused-end-cap-self-grip-suits-1-6mm-round-tube-316-stainless-mirror'
    },
    'HR-S-2017A': {
        title: 'HR-S-2017A',
        subtitle: 'Radiused End Cap Self Grip to suit 2" (50.8mm) x 1.5mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-2017A.jpg',
        price: 7.16,
        link: 'https://www.awrsolutions.com.au/products/radiused-end-cap-self-grip-suits-1-6mm-round-tube-316-stainless-satin'
    },
    'HR-2018A': {
        title: 'HR-2018A',
        subtitle: 'Domed End Cap to Suit 1.5mm Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-2018A.jpg',
        price: 13.18,
        link: 'https://www.awrsolutions.com.au/products/domed-end-cap-suits-1-6mm-round-tube-316-stainless-mirror'
    },
    'HR-S-2018A': {
        title: 'HR-S-2018A',
        subtitle: 'Domed End Cap to suit 2" (50.8mm) x 1.5mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-2018A.jpg',
        price: 13.18,
        link: 'https://www.awrsolutions.com.au/products/domed-end-cap-suits-50-8mm-x-1-6mm-round-tube-316-stainless-satin'
    },
    'HR-2019A': {
        title: 'HR-2019A',
        subtitle: 'Flat End Cap to Suit 1.5mm Round Tube 316 Grade Stainless Steel - Mirror Polish',
        thumbnailUrl: '/images/products/HR-2019A.jpg',
        price: 7.88,
        link: 'https://www.awrsolutions.com.au/products/flat-end-cap-suits-1-6mm-round-tube-316-stainless-mirror'
    },
    'HR-S-2019A': {
        title: 'HR-S-2019A',
        subtitle: 'Flat End Cap to suit 2" (50.8mm) x 1.5mm Round Tube 316 Grade Stainless Steel - Satin Finish',
        thumbnailUrl: '/images/products/HR-S-2019A.jpg',
        price: 7.88,
        link: 'https://www.awrsolutions.com.au/products/flat-end-cap-suits-1-6mm-round-tube-316-stainless-satin'
    },
    // Square
    'HR-SS-2002': {
        title: 'HR-SS-2002',
        subtitle: '90 Degree Elbow to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Satin Finish',
        thumbnailUrl: '/images/products/HR-SS-2002.jpg',
        price: 24.86,
        link: 'https://www.awrsolutions.com.au/products/90-degree-elbow-suits-50-8mm-x-1-6mm-square-tube-316-stainless-satin'
    },
    'HR-SS-2019': {
        title: 'HR-SS-2019',
        subtitle: 'Flat End Cap to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Satin Finish',
        thumbnailUrl: '/images/products/HR-SS-2019.jpg',
        price: 8.5,
        link: 'https://www.awrsolutions.com.au/products/flat-end-cap-suits-50-8mm-x-1-6mm-square-tube-316-stainless-satin'
    },
    'HR-SM-2019': {
        title: 'HR-SM-2019',
        subtitle: 'Flat End Cap to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Mirror Polish',
        thumbnailUrl: '/images/products/HR-SM-2019.jpg',
        price: 7.88,
        link: 'https://www.awrsolutions.com.au/products/flat-end-cap-suits-50-8mm-x-1-6mm-square-tube-316-stainless-mirror'
    },
    'HR-SS-2016': {
        title: 'HR-SS-2016',
        subtitle: 'Square Flange 4 Holes to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Satin Finish',
        thumbnailUrl: '/images/products/HR-SS-2016.jpg',
        price: 26.48,
        link: 'https://www.awrsolutions.com.au/products/square-flange-4-holes-suits-50-8mm-x-1-6mm-square-tube-316-stainless-satin'
    },
    'HR-SM-2016': {
        title: 'HR-SM-2016',
        subtitle: 'Square Flange 4 Holes to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Mirror Polish',
        thumbnailUrl: '/images/products/HR-SM-2016.jpg',
        price: 27.88,
        link: 'https://www.awrsolutions.com.au/products/square-flange-4-holes-suits-50-8mm-x-1-6mm-square-tube-316-stainless-mirror'
    },
    'HR-SS-2014': {
        title: 'HR-SS-2014',
        subtitle: 'Oblong Flange 2 Holes to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Satin Finish',
        thumbnailUrl: '/images/products/HR-SS-2014.jpg',
        price: 25.9,
        link: 'https://www.awrsolutions.com.au/products/oblong-flange-2-holes-suits-50-8mm-x-1-6mm-square-tube-316-stainless-satin'
    },
    'HR-SM-2014': {
        title: 'HR-SM-2014',
        subtitle: 'Oblong Flange 2 Holes to suit 2" (50.8mm) x 1.5mm Square Tube 316 Grade Stainless - Mirror Polish',
        thumbnailUrl: '/images/products/HR-SM-2014.jpg',
        price: 27.27,
        link: 'https://www.awrsolutions.com.au/products/oblong-flange-2-holes-suits-50-8mm-x-1-6mm-square-tube-316-stainless-mirror'
    },
    // #endregion
    // #region Grommets
    'GROM-L-BK': {
        title: 'GROM-L-BK',
        subtitle: 'Grommet Split for 3.2-4mm wire - Suits 3-4mm Wall Thickness - Black',
        thumbnailUrl: '/images/products/GROM-L-BK.jpg',
        price: 0.28,
        link: 'https://www.awrsolutions.com.au/products/grommet-split-for-3-2-4mm-wire-suits-3-4mm-wall-black-drill-hole'
    },
    'GROM-S-BK': {
        title: 'GROM-S-BK',
        subtitle: 'Grommet Split for 3.2-4mm wire- Suits 1.6‐2mm Wall Thickness - Black',
        thumbnailUrl: '/images/products/GROM-S-BK.jpg',
        price: 0.25,
        link: 'https://www.awrsolutions.com.au/products/grommet-split-for-3-2-4mm-wire-suits-1-6-2mm-wall'
    },
    'GROM-S-SR': {
        title: 'GROM-S-SR',
        subtitle: 'Grommet Split for 3.2-4mm wire - Suits 1.6‐2mm Wall Thickness - Silver',
        thumbnailUrl: '/images/products/GROM-S-SR.jpg',
        price: 0.25,
        link: 'https://www.awrsolutions.com.au/products/grommet-split-for-3-2-4mm-wire-suits-1-6-2mm-wall-silver-hole'
    },
    'GROM-SA-SR': {
        title: 'GROM-SA-SR',
        subtitle: 'Grommet Split for Stairs for 3.2-4mm wire - Suits angles 33-38 degrees - Suits 1.6‐2mm Wall Thickness - Silver - Drill Hole Size: 9.5mm',
        thumbnailUrl: '/images/products/GROM-SA-SR.jpg',
        price: 0.27,
        link: 'https://www.awrsolutions.com.au/products/grommet-split-for-stairs-for-3-2-4mm-wire-suits-angles-33-38-degrees-suits-1-6-2mm-wall-silver'
    },
    'GROM-LA-BK': {
        title: 'GROM-LA-BK',
        subtitle: 'Grommet Split for Stairs for 3.2-4mm wire - Suits angles 33-38 degrees - Suits 3-4mm Wall Thickness - Black - Drill Hole Size: 11mm',
        thumbnailUrl: '/images/products/GROM-LA-BK.jpg',
        price: 0.3,
        link: 'https://www.awrsolutions.com.au/products/grommet-split-for-stairs-for-3-2-4mm-wire-suits-angles-33-38-degrees-suits-3-4mm-wall-black'
    },
    'GROM-SA-BK': {
        title: 'GROM-SA-BK',
        subtitle: 'Grommet Split for Stairs for 3.2-4mm wire - Suits angles 33-38 degrees - Suits 1.6‐2mm Wall Thickness - Black - Drill Hole Size: 9.5mm',
        thumbnailUrl: '/images/products/GROM-SA-BK.jpg',
        price: 0.27,
        link: 'https://www.awrsolutions.com.au/products/grommet-split-for-stairs-for-3-2-4mm-wire-suits-angles-33-38-degrees-suits-1-6-2mm-wall-black'
    }
};
export const isWireSku = (sku)=>{
    return sku.startsWith('WRS') || sku.startsWith('BWRS');
};
export const isHandrailSku = (sku)=>{
    return sku.includes('316-2-MTR');
};

//# sourceMappingURL=products.js.map